export default "__VITE_ASSET__67b50f54__"